import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.user');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-page-admin-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.user/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminUserComponent implements OnInit, OnDestroy {
    public type: string | null = null;

    private routerSub: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {}

    public async ngOnInit() {
        await this.service.init();

        this.type = WizRoute.segment.type || null;
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newType = WizRoute.segment.type || null;
                if (newType !== this.type) {
                    this.type = newType;
                    await this.service.render();
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }
}

export default PageAdminUserComponent;